import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";

export default function Mission() {
  const slideInRight = {
    hidden: { opacity: 0, x: 100 }, // Start offscreen to the right
    visible: { opacity: 1, x: 0 }, // Slide into position
    transition: { duration: 1, ease: "easeInOut" },
  };

  // Create a reference for the container element
  const ref = useRef(null);

  // Detect when the container is in view
  const isInView = useInView(ref, { margin: "0px 0px -350px 0px" });

  return (
    <div ref={ref} className="flex bg-white h-[597px] w-[1440px] px-32 py-9">
      <img
        src="/icons/Mission/BOD-PETER.png"
        className="w-[601px] h-[504px]"
        alt="Mission image"
      />

      <div className="pl-16">
        <img src="/icons/Mission/heading-Kopie.png" alt="Heading" />

        {/* Vision Section with Animation */}
        <motion.div
          className="py-12  "
          variants={slideInRight}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"} // Animation only when in view
        >
          <h2 className="text-[#EB1F27] font-inter font-bold text-[25px]">
            VISION
          </h2>
          <h3 className="font-normal text-[18px] text-[#3A4366] text-justify">
            “To lead the way in business excellence by unleashing the power of
            resources, fostering innovation, and building enduring partnerships”
          </h3>
        </motion.div>

        {/* Mission Section with Delayed Animation */}
        <motion.div
          variants={slideInRight}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"} // Animation only when in view
          transition={{ delay: 0.5 }} // Adds a delay for the Mission section
        >
          <h2 className="text-[#EB1F27] font-inter font-bold text-[25px]">
            MISSION
          </h2>
          <h3 className="font-normal text-[18px] text-[#3A4366] text-justify">
            At Spiral, our mission is to harness the power of resources to fuel
            innovation and drive business excellence. We are dedicated to
            providing comprehensive outsourcing solutions that empower our
            clients to achieve continuous success and creating lasting value,
            anytime and anywhere.
          </h3>
        </motion.div>
      </div>
    </div>
  );
}
